
export default {
  name: 'FormField',
  props: {
    label: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    messages: {
      type: String
    }
  },
  computed: {
    getErrorMessage () {
      return this.messages || null
    }
  }
}
